// test152
(152 && 0);
